/**
 * `aria-describedby` value for a select whose registry notice may be showing.
 * Its own module so RegistryNotice.tsx stays component-only (fast-refresh rule).
 */
export const registryNoticeIds = (
  idPrefix: string,
  { empty, error }: { empty: boolean; error: boolean },
): string | undefined =>
  [error && `${idPrefix}-fetch-error`, empty && `${idPrefix}-hint`].filter(Boolean).join(' ') ||
  undefined;
